export default __webpack_public_path__ + "static/media/img_logo_hyundai.543a0e90.svg";